// extracted by mini-css-extract-plugin
export default {"container":"Co-z","heading":"Do-z","text":"Eo-z","info":"Fo-z","link":"Go-z","fullMaxWidth":"Ho-z"};